import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LEGAL_LINKS, SUPPORT_MAILTO } from "@/lib/company";
import { useI18n } from "@/i18n";

const LEGAL_KEY = { "/terms": "terms", "/privacy": "privacy", "/cookies": "cookies", "/legal": "legal" };

export function Footer() {
  const { t } = useI18n();
  const navLinks = t("nav.links");
  return (
    <footer className="border-t border-white/10 bg-re-ink pb-28 pt-16 lg:py-16" data-testid="footer">
      <div className="container-re">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div className="max-w-sm">
            <Logo variant="dark" />
            <p className="mt-5 text-sm leading-relaxed text-white/50">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">{t("footer.navHeading")}</p>
            <ul className="mt-5 space-y-3">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`/#${l.id}`} className="text-sm text-white/60 transition-colors hover:text-white" data-testid={`footer-nav-${l.id}`}>
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a href={SUPPORT_MAILTO} className="text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-contact">{t("footer.contact")}</a>
              </li>
              <li>
                <Link to="/login" className="text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-login">{t("footer.login")}</Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">{t("footer.legalHeading")}</p>
            <ul className="mt-5 space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/60 transition-colors hover:text-white" data-testid={l.testid}>
                    {t(`legalLinks.${LEGAL_KEY[l.to]}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8 text-center sm:text-left">
          <p className="text-xs text-white/55">{t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
}
